import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './Divider.scss';

export default function Divider(props) {
  const classnames = cx(props.className, 'Divider');

  return <hr className={classnames} />;
}

Divider.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ])
};
